import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password'); // Adjust 'password' to your control name
    const confirmPassword = control.get('confirmPassword'); // Adjust 'confirmPassword'

    if (!password || !confirmPassword) {
        return null; // Controls might not be initialized yet
    }
    // console.log(password.value === confirmPassword.value ? 'ok' : 'error');
    return password.value === confirmPassword.value ? null : { 'passwordMismatch': true };
};